import {
  GET_ALL_POST_ACTIONS,
  GET_POST_DETAILS_BY_ID_ACTIONS,
  GET_RECENT_POSTS_BY_USERID_ACTIONS,
} from "../../actionType/discussion";
import {
  CREATE_POST_NEW_ACTIONS,
  DELETE_POST_ID_ACTIONS,
  LIKE_UNLIKE_POST_AND_COMMENTS_ACTIONS,
  REPLAY_POST_NEW_ACTIONS,
  PUT_JOIN_POST_ACTIONS,
  UPDATE_REPLAY_POST_NEW_ACTIONS,
  POST_REPORT_ACTIONS,
  DELETE_COMMENTS_NEW_ACTIONS,
  GET_JOINED_POSTS_BY_USERID_ACTIONS
} from "../../actionType/discussion";

const intialState = {
  getAllPostData: [],
  isGetAllPostDataLoader: false,
  getTrendingPostData: [],
  isGetTrendingPostDataLoader: false,
  createPostData: {},
  isCreatePostDataLoader: false,
  UpdatePostData: {},
  isUpdatePostDataLoader: false,
  getPostDetailsData: [],
  isGetPostDetailsByIdLoader: false,
  getRecentPosts: [],
  isGetRecentPostsByIdLoader: false,
  getJoinedPosts: [],
  isGetJoinedPostsByIdLoader: false,
  deletePosts: [],
  isdeletepostLoader: false,
  isPostAndCommentsLikeUnLikeLoader: false,
  replayPostData: {},
  isReplayPostLoader: false,
  joinPost: [],
  isjoinPostLoader: false,
};

export const discussionReducer = (
  state = intialState,
  { type, payload }: any
) => {
  switch (type) {
    // get all post
    case GET_ALL_POST_ACTIONS.GET_ALL_POST_REQUEST:
      return { ...state, isGetAllPostDataLoader: true };
    case GET_ALL_POST_ACTIONS.GET_ALL_POST_RESPONSE:
      return {
        ...state,
        getAllPostData: payload,
        isGetAllPostDataLoader: false,
      };
    case GET_ALL_POST_ACTIONS.GET_ALL_POST_ERROR:
      return {
        ...state,
        getAllPostData: payload,
        isGetAllPostDataLoader: false,
      };

    //CREATE_POST_ACTIONS
    case CREATE_POST_NEW_ACTIONS.CREATE_POST_NEW_REQUEST:
      return { ...state, isCreatePostDataLoader: true };
    case CREATE_POST_NEW_ACTIONS.CREATE_POST_NEW_RESPONSE:
      return {
        ...state,
        createPostData: payload,
        isCreatePostDataLoader: false,
      };
    case CREATE_POST_NEW_ACTIONS.CREATE_POST_NEW_ERROR:
      return {
        ...state,
        createPostData: payload,
        isCreatePostDataLoader: false,
      };

    //UPDATE_POST_ACTIONS
    case CREATE_POST_NEW_ACTIONS.CREATE_POST_NEW_REQUEST:
      return { ...state, isCreatePostDataLoader: true };
    case CREATE_POST_NEW_ACTIONS.CREATE_POST_NEW_RESPONSE:
      return {
        ...state,
        createPostData: payload,
        isCreatePostDataLoader: false,
      };
    case CREATE_POST_NEW_ACTIONS.CREATE_POST_NEW_ERROR:
      return {
        ...state,
        createPostData: payload,
        isCreatePostDataLoader: false,
      };

    //get post by Id
    case GET_POST_DETAILS_BY_ID_ACTIONS.GET_POST_DETAILS_BY_ID_REQUEST:
      return { ...state, isGetPostDetailsByIdLoader: true };
    case GET_POST_DETAILS_BY_ID_ACTIONS.GET_POST_DETAILS_BY_ID_RESPONSE:
      return {
        ...state,
        getPostDetailsData: payload,
        isGetPostDetailsByIdLoader: false,
      };
    case GET_POST_DETAILS_BY_ID_ACTIONS.GET_POST_DETAILS_BY_ID_ERROR:
      return {
        ...state,
        getPostDetailsData: payload,
        isGetPostDetailsByIdLoader: false,
      };

    //get recent posts by user id
    case GET_RECENT_POSTS_BY_USERID_ACTIONS.GET_RECENT_POSTS_BY_USERID_REQUEST:
      return { ...state, isGetRecentPostsByIdLoader: true };
    case GET_RECENT_POSTS_BY_USERID_ACTIONS.GET_RECENT_POSTS_BY_USERID_RESPONSE:
      return {
        ...state,
        getRecentPosts: payload,
        isGetRecentPostsByIdLoader: false,
      };
    //get recent posts by user id
    case GET_JOINED_POSTS_BY_USERID_ACTIONS.GET_JOINED_POSTS_BY_USERID_REQUEST:
      return { ...state, isGetJoinedPostsByIdLoader: true };
    case GET_JOINED_POSTS_BY_USERID_ACTIONS.GET_JOINED_POSTS_BY_USERID_RESPONSE:
      return {
        ...state,
        getJoinedPosts: payload,
        isGetJoinedPostsByIdLoader: false,
      };
    case GET_JOINED_POSTS_BY_USERID_ACTIONS.GET_JOINED_POSTS_BY_USERID_ERROR:
      return {
        ...state,
        getJoinedPosts: payload,
        isGetJoinedPostsByIdLoader: false,
      };

    //get Trending posts
    case GET_ALL_POST_ACTIONS.GET_ALL_POST_REQUEST:
      return { ...state, isGetTrendingPostDataLoader: true };
    case GET_ALL_POST_ACTIONS.GET_ALL_POST_RESPONSE:
      return {
        ...state,
        getTrendingPostData: payload,
        isGetTrendingPostDataLoader: false,
      };
    case GET_ALL_POST_ACTIONS.GET_ALL_POST_ERROR:
      return {
        ...state,
        getTrendingPostData: payload,
        isGetTrendingPostDataLoader: false,
      };

    //delete posts
    case DELETE_POST_ID_ACTIONS.DELETE_POST_REQUEST:
      return { ...state, isdeletepostLoader: true };
    case DELETE_POST_ID_ACTIONS.DELETE_POST_RESPONSE:
      return {
        ...state,
        deletePosts: payload,
        isdeletepostLoader: false,
      };
    case DELETE_POST_ID_ACTIONS.DELETE_POST_ERROR:
      return {
        ...state,
        deletePosts: payload,
        isdeletepostLoader: false,
      };

    //REPLY COMMENT EDIT and comments
    case UPDATE_REPLAY_POST_NEW_ACTIONS.UPDATE_REPLAY_POST_NEW_REQUEST:
      return { ...state, isReplayPostLoader: true };
    case UPDATE_REPLAY_POST_NEW_ACTIONS.UPDATE_REPLAY_POST_NEW_RESPONSE:
      return { ...state, createPostData: payload, isReplayPostLoader: false };

    case UPDATE_REPLAY_POST_NEW_ACTIONS.UPDATE_REPLAY_POST_NEW_ERROR:
      return { ...state, isReplayPostLoader: false };

    //Like Unlike posts and comments
    case LIKE_UNLIKE_POST_AND_COMMENTS_ACTIONS.LIKE_UNLIKE_POST_AND_COMMENTS_REQUEST:
      return { ...state, isPostAndCommentsLikeUnLikeLoader: true };
    case LIKE_UNLIKE_POST_AND_COMMENTS_ACTIONS.LIKE_UNLIKE_POST_AND_COMMENTS_RESPONSE:
      return { ...state, isPostAndCommentsLikeUnLikeLoader: false };

    //Like Unlike posts and comments
    case LIKE_UNLIKE_POST_AND_COMMENTS_ACTIONS.LIKE_UNLIKE_POST_AND_COMMENTS_REQUEST:
      return { ...state, isPostAndCommentsLikeUnLikeLoader: true };
    case LIKE_UNLIKE_POST_AND_COMMENTS_ACTIONS.LIKE_UNLIKE_POST_AND_COMMENTS_RESPONSE:
      return { ...state, isPostAndCommentsLikeUnLikeLoader: false };

    case REPLAY_POST_NEW_ACTIONS.REPLAY_POST_NEW_REQUEST:
      return { ...state, isReplayPostLoader: true };
    case REPLAY_POST_NEW_ACTIONS.REPLAY_POST_NEW_RESPONSE:
      return { ...state, replayPostData: payload, isReplayPostLoader: false };

    case REPLAY_POST_NEW_ACTIONS.REPLAY_POST_NEW_ERROR:
      return { ...state, isReplayPostLoader: false };
    //PUT_JOIN_POST_ACTIONS
    case PUT_JOIN_POST_ACTIONS.PUT_JOIN_POST_REQUEST:
      return { ...state, isjoinPostLoader: true };
    case PUT_JOIN_POST_ACTIONS.PUT_JOIN_POST_RESPONSE:
      return {
        ...state,
        joinPost: payload,
        isjoinPostLoader: false,
      };
    case PUT_JOIN_POST_ACTIONS.PUT_JOIN_POST_ERROR:
      return {
        ...state,
        joinPost: payload,
        isjoinPostLoader: false,
      };

    //post report(requst  moderation)
    case POST_REPORT_ACTIONS.POST_REPORT_REQUEST:
      return { ...state, isPostRequestModerationLoader: true };
    case POST_REPORT_ACTIONS.POST_REPORT_RESPONSE:
      return { ...state, isPostRequestModerationLoader: false };
    case POST_REPORT_ACTIONS.POST_REPORT_ERROR:
      return { ...state, isPostRequestModerationLoader: false };
    //DELETE COMMENT ACTION  post
    case DELETE_COMMENTS_NEW_ACTIONS.DELETE_COMMENTS_NEW_REQUEST:
      return { ...state, isCommentsDeleteLoader: true };
    case DELETE_COMMENTS_NEW_ACTIONS.DELETE_COMMENTS_NEW_RESPONSE:
      return { ...state, isCommentsDeleteLoader: false };

    case DELETE_COMMENTS_NEW_ACTIONS.DELETE_COMMENTS_NEW_ERROR:
      return { ...state, isCommentsDeleteLoader: false }
    //default
    default:
      return state;
  }
};
